var map = {
	"./allocate.svg": 88676,
	"./archive.svg": 88618,
	"./arrow-down.svg": 33408,
	"./arrow-left.svg": 66600,
	"./arrow-right.svg": 29512,
	"./arrow-up.svg": 67903,
	"./bookmark.svg": 24376,
	"./calendar.svg": 73380,
	"./cancel.svg": 90830,
	"./caret-down.svg": 5720,
	"./caret-left.svg": 95535,
	"./caret-right.svg": 96177,
	"./caret-up.svg": 6439,
	"./cart.svg": 60591,
	"./check-circle.svg": 99623,
	"./check-in.svg": 89218,
	"./check-out.svg": 38975,
	"./chevron-double-left.svg": 60215,
	"./chevron-double-right.svg": 41282,
	"./chevron-left.svg": 98292,
	"./chevron-right.svg": 65220,
	"./clipboard.svg": 13413,
	"./clock.svg": 33979,
	"./combine.svg": 19951,
	"./comment.svg": 56699,
	"./dash.svg": 31679,
	"./default.svg": 56890,
	"./deselect-all.svg": 36791,
	"./diacritic.svg": 77061,
	"./document.svg": 6080,
	"./download.svg": 20776,
	"./drag-drop.svg": 91437,
	"./duplicate.svg": 97506,
	"./edit.svg": 66532,
	"./ellipsis.svg": 93544,
	"./end-mark.svg": 89393,
	"./envelope.svg": 15359,
	"./exclamation-circle.svg": 85499,
	"./external-link.svg": 35032,
	"./eye-closed.svg": 44213,
	"./eye-open.svg": 25860,
	"./flag.svg": 1772,
	"./gear.svg": 84771,
	"./house.svg": 9447,
	"./indexes.svg": 28572,
	"./info.svg": 69842,
	"./lightning.svg": 34450,
	"./link.svg": 38597,
	"./list.svg": 61992,
	"./lock.svg": 45224,
	"./play.svg": 71698,
	"./plus-sign.svg": 25419,
	"./preview.svg": 60954,
	"./print.svg": 41158,
	"./profile.svg": 39581,
	"./question-mark.svg": 12408,
	"./receive.svg": 36086,
	"./refresh.svg": 86335,
	"./replace.svg": 79093,
	"./report.svg": 36470,
	"./save.svg": 29569,
	"./search.svg": 34338,
	"./select-all.svg": 88273,
	"./source.svg": 82722,
	"./tag.svg": 50389,
	"./times-circle-solid.svg": 79473,
	"./times-circle.svg": 27737,
	"./times.svg": 78538,
	"./transfer.svg": 69637,
	"./trash.svg": 9521,
	"./triangle-down.svg": 35127,
	"./triangle-up.svg": 30821,
	"./unlink.svg": 35198,
	"@folio/stripes-components/lib/Icon/icons/allocate.svg": 88676,
	"@folio/stripes-components/lib/Icon/icons/archive.svg": 88618,
	"@folio/stripes-components/lib/Icon/icons/arrow-down.svg": 33408,
	"@folio/stripes-components/lib/Icon/icons/arrow-left.svg": 66600,
	"@folio/stripes-components/lib/Icon/icons/arrow-right.svg": 29512,
	"@folio/stripes-components/lib/Icon/icons/arrow-up.svg": 67903,
	"@folio/stripes-components/lib/Icon/icons/bookmark.svg": 24376,
	"@folio/stripes-components/lib/Icon/icons/calendar.svg": 73380,
	"@folio/stripes-components/lib/Icon/icons/cancel.svg": 90830,
	"@folio/stripes-components/lib/Icon/icons/caret-down.svg": 5720,
	"@folio/stripes-components/lib/Icon/icons/caret-left.svg": 95535,
	"@folio/stripes-components/lib/Icon/icons/caret-right.svg": 96177,
	"@folio/stripes-components/lib/Icon/icons/caret-up.svg": 6439,
	"@folio/stripes-components/lib/Icon/icons/cart.svg": 60591,
	"@folio/stripes-components/lib/Icon/icons/check-circle.svg": 99623,
	"@folio/stripes-components/lib/Icon/icons/check-in.svg": 89218,
	"@folio/stripes-components/lib/Icon/icons/check-out.svg": 38975,
	"@folio/stripes-components/lib/Icon/icons/chevron-double-left.svg": 60215,
	"@folio/stripes-components/lib/Icon/icons/chevron-double-right.svg": 41282,
	"@folio/stripes-components/lib/Icon/icons/chevron-left.svg": 98292,
	"@folio/stripes-components/lib/Icon/icons/chevron-right.svg": 65220,
	"@folio/stripes-components/lib/Icon/icons/clipboard.svg": 13413,
	"@folio/stripes-components/lib/Icon/icons/clock.svg": 33979,
	"@folio/stripes-components/lib/Icon/icons/combine.svg": 19951,
	"@folio/stripes-components/lib/Icon/icons/comment.svg": 56699,
	"@folio/stripes-components/lib/Icon/icons/dash.svg": 31679,
	"@folio/stripes-components/lib/Icon/icons/default.svg": 56890,
	"@folio/stripes-components/lib/Icon/icons/deselect-all.svg": 36791,
	"@folio/stripes-components/lib/Icon/icons/diacritic.svg": 77061,
	"@folio/stripes-components/lib/Icon/icons/document.svg": 6080,
	"@folio/stripes-components/lib/Icon/icons/download.svg": 20776,
	"@folio/stripes-components/lib/Icon/icons/drag-drop.svg": 91437,
	"@folio/stripes-components/lib/Icon/icons/duplicate.svg": 97506,
	"@folio/stripes-components/lib/Icon/icons/edit.svg": 66532,
	"@folio/stripes-components/lib/Icon/icons/ellipsis.svg": 93544,
	"@folio/stripes-components/lib/Icon/icons/end-mark.svg": 89393,
	"@folio/stripes-components/lib/Icon/icons/envelope.svg": 15359,
	"@folio/stripes-components/lib/Icon/icons/exclamation-circle.svg": 85499,
	"@folio/stripes-components/lib/Icon/icons/external-link.svg": 35032,
	"@folio/stripes-components/lib/Icon/icons/eye-closed.svg": 44213,
	"@folio/stripes-components/lib/Icon/icons/eye-open.svg": 25860,
	"@folio/stripes-components/lib/Icon/icons/flag.svg": 1772,
	"@folio/stripes-components/lib/Icon/icons/gear.svg": 84771,
	"@folio/stripes-components/lib/Icon/icons/house.svg": 9447,
	"@folio/stripes-components/lib/Icon/icons/indexes.svg": 28572,
	"@folio/stripes-components/lib/Icon/icons/info.svg": 69842,
	"@folio/stripes-components/lib/Icon/icons/lightning.svg": 34450,
	"@folio/stripes-components/lib/Icon/icons/link.svg": 38597,
	"@folio/stripes-components/lib/Icon/icons/list.svg": 61992,
	"@folio/stripes-components/lib/Icon/icons/lock.svg": 45224,
	"@folio/stripes-components/lib/Icon/icons/play.svg": 71698,
	"@folio/stripes-components/lib/Icon/icons/plus-sign.svg": 25419,
	"@folio/stripes-components/lib/Icon/icons/preview.svg": 60954,
	"@folio/stripes-components/lib/Icon/icons/print.svg": 41158,
	"@folio/stripes-components/lib/Icon/icons/profile.svg": 39581,
	"@folio/stripes-components/lib/Icon/icons/question-mark.svg": 12408,
	"@folio/stripes-components/lib/Icon/icons/receive.svg": 36086,
	"@folio/stripes-components/lib/Icon/icons/refresh.svg": 86335,
	"@folio/stripes-components/lib/Icon/icons/replace.svg": 79093,
	"@folio/stripes-components/lib/Icon/icons/report.svg": 36470,
	"@folio/stripes-components/lib/Icon/icons/save.svg": 29569,
	"@folio/stripes-components/lib/Icon/icons/search.svg": 34338,
	"@folio/stripes-components/lib/Icon/icons/select-all.svg": 88273,
	"@folio/stripes-components/lib/Icon/icons/source.svg": 82722,
	"@folio/stripes-components/lib/Icon/icons/tag.svg": 50389,
	"@folio/stripes-components/lib/Icon/icons/times-circle-solid.svg": 79473,
	"@folio/stripes-components/lib/Icon/icons/times-circle.svg": 27737,
	"@folio/stripes-components/lib/Icon/icons/times.svg": 78538,
	"@folio/stripes-components/lib/Icon/icons/transfer.svg": 69637,
	"@folio/stripes-components/lib/Icon/icons/trash.svg": 9521,
	"@folio/stripes-components/lib/Icon/icons/triangle-down.svg": 35127,
	"@folio/stripes-components/lib/Icon/icons/triangle-up.svg": 30821,
	"@folio/stripes-components/lib/Icon/icons/unlink.svg": 35198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7406;